export const usePlans = true;
export const useMaterialsPlan = false;
export const usePrices = false;
// export const usePricingTypes = true;
export const usePricingTypes = false;
export const showEntityAddressInMenus = true;
export const addingCustomerDirectly = false;
export const useFinancialTarget = false;
export const useNotifications = true;
export const useDirectEntityModify = true;
export const useMaterialsSpecialtyVisits = false;

export const disabledFriday = false;
export const enableVacations = false;
export const deletionExternal = true